import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaFacebook, FaTiktok, FaLinkedin, FaTwitter, FaEnvelope, FaWhatsapp } from 'react-icons/fa';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-columns">
          <div className="footer-column">
            <div className="footer-brand">
              <img src={`${process.env.PUBLIC_URL}/logo130426.jpg`} alt="CICJ Logo" className="footer-logo" />
              <p className="footer-title">CICJ</p>
            </div>
            <p>&copy; {currentYear} CICJ.</p>
            <p>Tous droits réservés.</p>
            <p>Version 2.0</p>
          </div>

          <div className="footer-column">
            <p className="footer-title">Services</p>
            <Link to="/louer">Louer</Link>
            <Link to="/acheter">Acheter</Link>
            <Link to="/confier-mon-bien">Confier mon bien</Link>
            <Link to="/projet-immobilier">Projet immobilier</Link>
            <Link to="/conseils-consultance">Conseils & Consultance</Link>
            <Link to="/btp-construction">BTP & Construction</Link>
          </div>

          <div className="footer-column">
            <p className="footer-title">Informations</p>
            <Link to="/qui-sommes-nous">Qui sommes-nous</Link>
            <Link to="/partenaires">Partenaires</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/confidentialite">Confidentialité</Link>
            <Link to="/cgv">CGV</Link>
          </div>

          <div className="footer-column">
            <p className="footer-title">Suivez-nous</p>
            <div className="social-icons">
              <a href="/contact" title="Contact">
                <FaEnvelope />
              </a>
              <a href="https://wa.me/221776759906?text=Bonjour%2C%20je%20souhaite%20des%20informations%20sur%20vos%20services%20immobiliers" target="_blank" rel="noopener noreferrer" title="WhatsApp">
                <FaWhatsapp />
              </a>
              <a href="https://www.facebook.com/share/16fRWwqg3C/" target="_blank" rel="noopener noreferrer" title="Facebook">
                <FaFacebook />
              </a>
              <a href="https://www.tiktok.com/@cicj_immo?_t=ZM-8yP3KDCXHTa&_r=1" target="_blank" rel="noopener noreferrer" title="Tiktok">
                <FaTiktok />
              </a>
              <a href="https://www.linkedin.com/in/cicj-immo-7ab76a32a" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                <FaLinkedin />
              </a>
              <a href="https://x.com/cicjimmo" target="_blank" rel="noopener noreferrer" title="Twitter">
                <FaTwitter />
              </a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;